import React from 'react';
import './Testimonials.css';
import { useLanguage } from './LanguageContext';
import { translations } from './translations';

function Testimonials() {
  const { language } = useLanguage();
  const t = translations[language];

  const testimonials = [
    {
      name: t.testimonial1Name,
      story: t.testimonial1Text
    },
    {
      name: t.testimonial2Name,
      story: t.testimonial2Text
    }
  ];

  return (
    <div className="Testimonials">
      <h2>{t.successStories}</h2>
      <div className="testimonial-list">
        {testimonials.map(testimonial => (
          <div key={testimonial.name} className="testimonial">
            <h4>{testimonial.name}</h4>
            <p>"{testimonial.story}"</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Testimonials;
